module.exports = __webpack_public_path__ + "img/avatar4.751e7dbb.png";